<template>
  <multiple-actions-menu
      :options="actionsOptions"
      @onAction="onAction"
      v-on:click.stop
    ></multiple-actions-menu>
</template>

<script>
import MultipleActionsMenu from '@/components/commons/MultipleActionsMenu'
import Api from '@/api'

export default {
  name: "ProjectActionMenu",
  components: {MultipleActionsMenu},
  props: ['project'],
  computed: {
    actionsOptions() {
      let opts = [
          //{label:'Edit', event:'edit'},
          //{label:'Duplicate', event:'duplicate'},
          {label:'Close', event:'close'},
          {label:'Archive', event:'archive'}
        ]
      if(this.project.status == 'closed'){
        opts = [
          {label:'Open', event:'open'}
        ]
      } else if(this.project.status == 'archived'){
        opts = [
          {label:'Unarchive', event:'unarchive'}
        ]
      }
      return opts
    }
  },
  methods: {
    onAction(evt) {
      console.log(evt)
      switch (evt) {
        case 'edit':
          this.$router.push({path: `/project/${this.project.id}`, query: {currentView: 'description', editMode: true}})
          break
        case 'archive':
          Api.setProjectStatus(this.project,'archived')
          break
        case 'close':
          Api.setProjectStatus(this.project,'closed')
          break
        case 'open':
          Api.setProjectStatus(this.project,'ongoing')
          break
        case 'unarchive':
          Api.setProjectStatus(this.project,'ongoing')
          break
      }
    }
  }
}
</script>

<style lang="stylus" scoped>

</style>